import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './RecordNav.scss';

// Previous / next record arrows for a detail page header (vente, facture, paiement, retour),
// each with a two-line label underneath ("Vente / précédente"). Pairs with useRecordNeighbors.
// noun: the record name; feminine: agrees "précédente/suivante" vs "précédent/suivant".
// "Précédent(e)" = the older record, "suivant(e)" = the newer one; a missing id disables that arrow.
export default function RecordNav({ neighbors, onNavigate, noun, feminine = false }) {
  const previousWord = feminine ? 'précédente' : 'précédent';
  const nextWord = feminine ? 'suivante' : 'suivant';

  return (
    <div className="record-nav">
      <button
        type="button"
        className="record-nav__btn"
        onClick={() => onNavigate(neighbors?.previousId)}
        disabled={!neighbors?.previousId}
        data-tooltip-id="tooltip"
        data-tooltip-content={`${noun} ${previousWord} (←)`}
        aria-label={`${noun} ${previousWord}`}
      >
        <span className="record-nav__icon"><FontAwesomeIcon icon={faChevronLeft} /></span>
        <span className="record-nav__label">{noun}<br />{previousWord}</span>
      </button>
      <button
        type="button"
        className="record-nav__btn"
        onClick={() => onNavigate(neighbors?.nextId)}
        disabled={!neighbors?.nextId}
        data-tooltip-id="tooltip"
        data-tooltip-content={`${noun} ${nextWord} (→)`}
        aria-label={`${noun} ${nextWord}`}
      >
        <span className="record-nav__icon"><FontAwesomeIcon icon={faChevronRight} /></span>
        <span className="record-nav__label">{noun}<br />{nextWord}</span>
      </button>
    </div>
  );
}
